import ListGroup from 'react-bootstrap/ListGroup';
import Row from 'react-bootstrap/Row';

function ContenIndex() {
  return (
    <Row className='contents'>
      <h5>Quick Jump to Section</h5>
      <div>
        {/* <!-- Contents div start --> */}
        <ListGroup className='mb-5'>
          <ListGroup.Item><a href="#maths-section">Maths</a></ListGroup.Item>
          <ListGroup.Item><a href="#logical-section">Logical</a></ListGroup.Item>
          <ListGroup.Item><a href="#comp-section">Computer</a></ListGroup.Item>
          <ListGroup.Item><a href="#eng-section">English</a></ListGroup.Item>
        </ListGroup>
        {/* <!-- Contents div end --> */}
      </div>
    </Row>
  );
}

export default ContenIndex;
